import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { renderInlineBadge } from 'lib/hooks/useCaptchaGeneration';
import styles from './RecaptchaBadge.module.scss';

export interface RecaptchaBadgeProps {
  className?: string;
}

/**
 * reCAPTCHA badge component for displaying Google reCAPTCHA badge
 * This component renders the invisible reCAPTCHA badge that appears inline.
 *
 * The badge is rendered explicitly on mount (instead of relying on reCAPTCHA's one-time
 * auto-render of `.g-recaptcha` elements) so it reappears after client-side navigation,
 * not only on the initial load or a hard refresh.
 */
export function RecaptchaBadge({ className }: RecaptchaBadgeProps): JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    renderInlineBadge(container);
  }, []);

  return <div ref={containerRef} className={clsx(styles.recaptcha, className)} />;
}
